import * as Yup from 'yup';

import { yupPasswordSchema } from '/b2b/common/helpers/Password';

export const resetPasswordSchema = Yup.object().shape({
    username: Yup.string().email().max(128).required(),
    code: Yup.string().min(6).max(6).required(),
    newPassword: yupPasswordSchema.clone().required(),
    confirmNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'password.validations.notMatching')
        .required(),
});
